module.exports = __webpack_public_path__ + "img/kos45-02.0c54d34c.png";